import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ip.management.offices');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-ip-management-offices',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ip.management.offices/view.scss */
:host {
  display: block;
  height: 100%;
}

.ipm-office-registration-backdrop {
  position: fixed;
  z-index: 90;
  inset: 0;
  width: 100vw;
  max-width: none !important;
  height: 100vh;
  height: 100dvh;
  margin: 0 !important;
  padding: 0;
  border: 0;
  background: rgba(9, 30, 20, 0.56);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  cursor: default;
}

.ipm-office-registration-backdrop:disabled {
  cursor: wait;
}

.ipm-office-registration-modal {
  position: fixed;
  z-index: 100;
  top: 50%;
  left: 50%;
  display: flex;
  width: min(68rem, 100vw - 2rem);
  max-height: calc(100vh - 2rem);
  max-height: calc(100dvh - 2rem);
  flex-direction: column;
  overflow: hidden;
  transform: translate(-50%, -50%);
  border: 1px solid #dce7e0;
  border-radius: 1rem;
  color: #10241a;
  background: #fff;
  box-shadow: 0 30px 90px rgba(7, 29, 18, 0.28);
  animation: ipm-office-registration-enter 180ms ease-out both;
}

.ipm-office-registration-header {
  display: flex;
  flex: 0 0 auto;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.1rem;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
}

.ipm-office-registration-body {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 1rem;
  background: #f8fafc;
}

.ipm-office-registration-card {
  min-width: 0;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  background: #fff;
}

.ipm-office-registration-footer {
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.85rem 1rem;
  border-top: 1px solid #e2e8f0;
  background: #fff;
}

@keyframes ipm-office-registration-enter {
  from {
    opacity: 0;
    transform: translate(-50%, calc(-50% + 0.75rem)) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
@media (max-width: 640px) {
  .ipm-office-registration-modal {
    width: calc(100vw - 1rem);
    max-height: calc(100vh - 1rem);
    max-height: calc(100dvh - 1rem);
    border-radius: 0.85rem;
  }
  .ipm-office-registration-header,
  .ipm-office-registration-body,
  .ipm-office-registration-footer {
    padding: 0.75rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .ipm-office-registration-modal {
    animation-duration: 0.01ms;
    animation-iteration-count: 1;
  }
}`],
})
export class PageIpManagementOfficesComponent implements OnInit {
    public items: any[] = [];
    public pagination: any = { page: 1, total_pages: 1, total: 0 };
    public statuses: string[] = ['DRAFT', 'APPROVED', 'PROVISIONING', 'INVITED', 'ACTIVE', 'FAILED', 'SUSPENDED', 'TERMINATED'];
    public filterStatus = '';
    public officeName = '';
    public planCode = '';
    public planOptions = [
        { code: 'IP-MGMT-A', label: 'A타입', people: '3명 이내', price: '월 100,000원' },
        { code: 'IP-MGMT-B', label: 'B타입', people: '6명 이내', price: '월 150,000원' },
        { code: 'IP-MGMT-C', label: 'C타입', people: '10명 이내', price: '월 200,000원' },
        { code: 'IP-MGMT-D', label: 'D타입', people: '10명 초과', price: '월 200,000원 + 초과 1인당 10,000원' }
    ];
    public officeId = '';
    public contractId = '';
    public loading = false;
    public submitting = false;
    public registrationOpen = false;
    public registrationError = '';
    public deletingId = '';
    public errorMessage = '';
    public successMessage = '';

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.restoreDraftIds();
        await this.load();
    }

    public get selectedPlan() {
        return this.planOptions.find((item) => item.code === this.planCode) || null;
    }

    public get pageNumbers(): number[] {
        const total = Math.max(Number(this.pagination?.total_pages || 1), 1);
        return Array.from({ length: total }, (_, index) => index + 1);
    }

    public async openRegistration() {
        this.registrationOpen = true;
        this.registrationError = '';
        await this.service.render();
        setTimeout(() => document.getElementById('office-registration-name')?.focus(), 0);
    }

    public async closeRegistration() {
        if (this.submitting) return;
        this.registrationOpen = false;
        this.registrationError = '';
        await this.service.render();
    }

    public planLabel(code: string): string {
        return this.planOptions.find((item) => item.code === code)?.label || code || '-';
    }

    private newId(prefix: string): string {
        const bytes = new Uint8Array(16);
        globalThis.crypto.getRandomValues(bytes);
        return prefix + '-' + Array.from(bytes).map(v => v.toString(16).padStart(2, '0')).join('');
    }

    private restoreDraftIds() {
        try {
            const saved = JSON.parse(sessionStorage.getItem('ipm-onboarding-draft-ids') || '{}');
            this.officeId = typeof saved.officeId === 'string' && saved.officeId ? saved.officeId : this.newId('office');
            this.contractId = typeof saved.contractId === 'string' && saved.contractId ? saved.contractId : this.newId('contract');
        } catch (_error) {
            this.officeId = this.newId('office');
            this.contractId = this.newId('contract');
        }
        sessionStorage.setItem('ipm-onboarding-draft-ids', JSON.stringify({ officeId: this.officeId, contractId: this.contractId }));
    }

    private unwrap(response: any, fallback: string): any {
        const code = Number(response?.code || 0);
        if (code >= 200 && code < 300) return response?.data;
        throw new Error(response?.data?.error?.message || fallback);
    }

    public async load(page: number = 1) {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const result = this.unwrap(await wiz.call('list_onboardings', { page, status: this.filterStatus }), '개통 현황을 불러오지 못했습니다.');
            this.items = result.items || [];
            this.pagination = result.pagination || { page: 1, total_pages: 1, total: 0 };
        } catch (error: any) {
            this.items = [];
            this.errorMessage = error?.message || '개통 현황을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async register() {
        const name = this.officeName.trim();
        const plan = this.planCode.trim();
        if (!name || !this.planOptions.some((item) => item.code === plan)) {
            this.registrationError = '사무소명과 계약 타입을 선택해주세요.';
            await this.service.render();
            return;
        }
        this.submitting = true;
        this.registrationError = '';
        this.successMessage = '';
        await this.service.render();
        const data = {
            organization: { office_id: this.officeId, legal_name: name },
            contract: { contract_id: this.contractId, plan_code: plan, status: 'DRAFT' }
        };
        try {
            const result = this.unwrap(await wiz.call('register_onboarding', { data: JSON.stringify(data) }), '사무소를 등록하지 못했습니다.');
            const id = result?.provisioning?.id;
            if (!id) throw new Error('등록 응답에 온보딩 ID가 없습니다. 목록에서 등록 상태를 확인해주세요.');
            sessionStorage.removeItem('ipm-onboarding-draft-ids');
            this.registrationOpen = false;
            this.successMessage = '사무소가 등록되었습니다. 계약을 승인한 뒤 개통할 수 있습니다.';
            this.service.href('/ip-management/offices/' + id);
        } catch (error: any) {
            this.registrationError = error?.message || '사무소를 등록하지 못했습니다. 같은 입력으로 다시 시도할 수 있습니다.';
        } finally {
            this.submitting = false;
            await this.service.render();
        }
    }

    public async remove(event: Event, item: any) {
        event.stopPropagation();
        if (this.deletingId) return;

        const officeName = String(item?.legal_name || '이 사무소');
        const confirmed = await this.service.modal.show({
            title: '사무소 삭제',
            message: officeName + ' 사무소를 정말 삭제하시겠습니까? 삭제한 사무소는 복구할 수 없습니다.',
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!confirmed) return;

        this.deletingId = String(item?.id || '');
        this.errorMessage = '';
        this.successMessage = '';
        await this.service.render();

        try {
            this.unwrap(
                await wiz.call('delete_onboarding', { id: this.deletingId }),
                '사무소를 삭제하지 못했습니다.'
            );
            this.successMessage = officeName + ' 사무소를 삭제했습니다.';
            const page = this.items.length === 1 && this.pagination.page > 1
                ? this.pagination.page - 1
                : this.pagination.page;
            await this.load(page);
        } catch (error: any) {
            this.errorMessage = error?.message || '사무소를 삭제하지 못했습니다.';
        } finally {
            this.deletingId = '';
            await this.service.render();
        }
    }

    public open(item: any) {
        this.service.href('/ip-management/offices/' + item.id);
    }
}

export default PageIpManagementOfficesComponent;